import React, { useEffect, useState } from "react";
import axios from "axios";
// import "./HoAccounts.css";

const HoAccounts = () => {
  const summaryDate = localStorage.getItem("SummaryDate");
  const [TrOutletId, setOutlet] = useState(null);
  const [addAccsTrns, setAddAccsTrns] = useState({
    Outlet_Id: null,
    isOutletPosted: true,
    Tr_date: summaryDate,
    MainAc_id: "",
    SubAc_id: "",
    SubsubAc_id: "",
    Bill_dt: "",
    Bill_no: "",
    Supp_id: "",
    Supp_name: "",
    CrDr: "Dr",
    Narration: "",
    AmtCash: 0.0,
    AmtBank: 0.0,
    created_by: "",
    created_date: "",
  });
  const [accountsheadardata, setAccountsheadardata] = useState([]);
  const [editRowId, setEditRowId] = useState(null);
  const [editFormData, setEditFormData] = useState({
    Narration: "",
    AmtCash: 0,
    AmtBank: 0,
    SubsubAc_id: "",
    SubAc_id: "",
    MainAc_id: "",
    AccountName: "",
  });

  const [errors, setErrors] = useState({});
  const [AccountselectedId, setAccountSelectedId] = useState("");
  const [getAccsTrnsData, setGetAccsTrnsData] = useState([]);
  const apiUrl = process.env.REACT_APP_SERVER_API;
  const [saleSummarydata, setsaleSummarydata] = useState([]);
  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().split("T")[0]
  );

  const openingCash = parseFloat(localStorage.getItem("OpeningCash") || 0);
  const openingOfficeCash = parseFloat(
    localStorage.getItem("OpeningOfficeCash") || 0
  );

  useEffect(() => {
    const selectedOutlet = JSON.parse(localStorage.getItem("SelectedOutlet"));
    if (selectedOutlet) {
      setOutlet(selectedOutlet);
    }
  }, []);

  const fetchData = async () => {
    try {
      const resp = await axios.get(
        `${apiUrl}account-outlet/${TrOutletId.outlate_id}/4/1`
      );
      setAccountsheadardata(resp.data);
    } catch (error) {
      console.error("Error fetching account heads", error);
    }
  };

  useEffect(() => {
    if (TrOutletId?.outlate_id) {
      setAddAccsTrns((prev) => ({ ...prev, Outlet_Id: TrOutletId.outlate_id }));
      FatchCashBalances();
      FatchAccTransaction();
      fetchData();
    }
  }, [TrOutletId]);

  const AddAccTransaction = async () => {
    let hasError = false;

    if (!addAccsTrns.Narration || addAccsTrns.Narration.trim() === "") {
      setErrors((prev) => ({ ...prev, Narration: "Narration is required" }));
      hasError = true;
    } else {
      setErrors((prev) => ({ ...prev, Narration: null }));
    }

    const cash = parseFloat(addAccsTrns.AmtCash) || 0;
    const bank = parseFloat(addAccsTrns.AmtBank) || 0;

    if (cash === 0 && bank === 0) {
      setErrors((prev) => ({
        ...prev,
        Amount: "Either Cash or Bank amount is required",
      }));
      hasError = true;
    } else {
      setErrors((prev) => ({ ...prev, Amount: null }));
    }

    if (hasError) return;
    const updatedTrns = { ...addAccsTrns, Tr_date: summaryDate };
    setAddAccsTrns(updatedTrns);
    try {
      await axios.post(`${apiUrl}Accounts`, updatedTrns);
      FatchAccTransaction();
      ClearInputs();
    } catch (error) {
      console.error("Transaction Posting Error", error);
    }
  };

  const ClearInputs = () => {
    setAddAccsTrns((prev) => ({
      ...prev,
      Narration: "",
      AmtCash: 0,
      AmtBank: 0,
      SubsubAc_id: "",
      AccountName: "",
    }));
    setAccountSelectedId("");
  };

  

 

  const FatchAccTransaction = async (outletId, date) => {
    try {
      const formattedDate = new Date(date).toISOString().split("T")[0];
      const response = await axios.get(`${apiUrl}accounts-history`, {
        params: {
          Outlet_Id: outletId,
          Tr_date: formattedDate,
        },
      });
      setGetAccsTrnsData(response.data);
    } catch (error) {
      console.error("Error fetching sale summary:", error);
    }
  };

  const FatchCashBalances = async (outletId, selectedDate) => {
    try {
      const resp = await axios.get(`${apiUrl}cash-SummaryByOutletAndDate`, {
        params: { outletId, summaryDate: selectedDate },
      });
      const { OpeningCash, OfficeOpeningCash, SummaryDate, GST, VAT } =
        resp.data.data;
      localStorage.setItem("OpeningCash", OpeningCash);
      localStorage.setItem("OpeningOfficeCash", OfficeOpeningCash);
      localStorage.setItem("GSTAmount", GST);
      localStorage.setItem("VATAmount", VAT);

      const dateObj = new Date(SummaryDate);
      const formattedDate = `${String(dateObj.getDate()).padStart(
        2,
        "0"
      )}/${String(dateObj.getMonth() + 1).padStart(
        2,
        "0"
      )}/${dateObj.getFullYear()}`;
      localStorage.setItem("SummaryDate", formattedDate);
    } catch (error) {
      console.error("Error fetching cash balances:", error);
    }
  };

  const handleShowBackDate = () => {
    if (TrOutletId?.outlate_id && selectedDate) {
      FatchAccTransaction(TrOutletId.outlate_id, selectedDate);
      FatchCashBalances(TrOutletId.outlate_id, selectedDate);
    }
  };

  const changeDate = (direction) => {
    const newDate = new Date(selectedDate);
    newDate.setDate(newDate.getDate() + direction);
    setSelectedDate(newDate.toISOString().split("T")[0]);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setAddAccsTrns((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleEditClick = (item) => {
    setEditRowId(item.Tr_Id);
    setEditFormData({
      Narration: item.Narration || "",
      AmtCash: item.AmtCash || 0,
      AmtBank: item.AmtBank || 0,
    });
  };

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleEditSave = async (trId) => {
    try {
      const payload = {
        Narration: editFormData.Narration,
        AmtCash: editFormData.AmtCash,
        AmtBank: editFormData.AmtBank,
        SubsubAc_id: editFormData.SubsubAc_id,
        SubAc_id: editFormData.SubAc_id,
        MainAc_id: editFormData.MainAc_id,
        AccountName: editFormData.AccountName,
      };

      await axios.put(`${apiUrl}/Accounts-History/${trId}`, payload);
      setEditRowId(null);
      FatchAccTransaction(TrOutletId.outlate_id, selectedDate);
    } catch (error) {
      console.error("Edit Transaction Error", error);
    }
  };

  const filteredData = getAccsTrnsData.filter(
    (item) => item.MainAc_id == 4 && item.SubAc_id >= 1 && item.SubAc_id < 99
  );

  const totalAmtCash = filteredData.reduce(
    (sum, item) => sum + parseFloat(item.AmtCash || 0),
    0
  );
  const totalAmtBank = filteredData.reduce(
    (sum, item) => sum + parseFloat(item.AmtBank || 0),
    0
  );
  const totalCombined = totalAmtCash + totalAmtBank;

  return (
    <div className="container-fluid">
      <div className="row border">
        <div className="col-md-12">
          <div className="d-flex justify-content-between">
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="dateOption"
                checked
                readOnly
              />
              <label className="form-check-label">Back Date</label>
              <div className="d-flex align-items-center mt-2">
                <input
                  type="date"
                  className="form-control me-2 p-0"
                  value={selectedDate}
                  onChange={(e) => setSelectedDate(e.target.value)}
                />
                <button
                  className="btn btn-success me-2 p-1"
                  style={{ width: "55px" }}
                  onClick={() => changeDate(-1)}
                >
                  Prev
                </button>
                <button
                  className="btn btn-success p-1 me-2"
                  style={{ width: "55px" }}
                  onClick={() => changeDate(1)}
                >
                  Next
                </button>
                <button
                  className="btn btn-primary me-2 p-1"
                  onClick={handleShowBackDate}
                >
                  Show
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-8">
          <div className="d-flex justify-content-center align-items-center my-2">
            <h5 className="me-3">Expenses</h5>
            <h6 className="text-muted">{summaryDate}</h6>
          </div>
          <div className="d-flex">
            <div className="col-md-3 me-2">
              <select
                className="form-select"
                value={addAccsTrns.SubsubAc_id || ""}
                onChange={(e) => {
                  const selectedId = parseInt(e.target.value);
                  setAccountSelectedId(selectedId);
                  const selectedItem = accountsheadardata.find(
                    (item) => item.SubsubAc_id === selectedId
                  );
                  if (selectedItem) {
                    setAddAccsTrns((prev) => ({
                      ...prev,
                      SubAc_id: selectedItem.SubAc_id,
                      MainAc_id: selectedItem.MainAc_id,
                      SubsubAc_id: selectedItem.SubsubAc_id,
                      AccountName: selectedItem.AccountName,
                      Narration: selectedItem.AccountName,
                    }));
                  }
                }}
              >
                <option value="">Select Expenses Account</option>
                {accountsheadardata.map((item) => (
                  <option key={item._id} value={item.SubsubAc_id}>
                    {item.AccountName}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-md-4 me-2">
              <input
                className={`form-control ${
                  errors.Narration ? "is-invalid" : ""
                }`}
                type="text"
                name="Narration"
                value={addAccsTrns.Narration}
                onChange={handleInputChange}
                placeholder={addAccsTrns.AccountName || "Enter Narration"}
                readOnly
              />
              {errors.Narration && (
                <div className="invalid-feedback">{errors.Narration}</div>
              )}
            </div>
            <div className="col-md-2 me-2">
              <input
                className={`form-control text-end ${
                  errors.Amount ? "is-invalid" : ""
                }`}
                type="text"
                name="AmtCash"
                value={addAccsTrns.AmtCash}
                onChange={handleInputChange}
                readOnly
              />
            </div>
            <div className="col-md-2 me-2">
              <input
                className={`form-control text-end ${
                  errors.Amount ? "is-invalid" : ""
                }`}
                type="text"
                name="AmtBank"
                value={addAccsTrns.AmtBank}
                onChange={handleInputChange}
                readOnly
              />
              {errors.Amount && (
                <div className="invalid-feedback">{errors.Amount}</div>
              )}
            </div>
            <div className="col-md-2 me-2">
              <button
                className="btn btn-success w-75"
                // disabled={!AccountselectedId}
                disabled
                onClick={AddAccTransaction}
              >
                Save
              </button>
            </div>
          </div>

          <div className="table-responsive mt-3">
            <table className="table tblcss">
              <thead className="text-center">
                <tr>
                  <th className="tdcss">Account Name</th>
                  <th className="tdcss" style={{ width: "40%" }}>
                    Particulars
                  </th>
                  <th className="tdcss">Cash Rs.</th>
                  <th className="tdcss">Bank Rs.</th>
                  <th className="tdcss" style={{ width: "100px" }}>
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {[...filteredData].reverse().map((item, index) => {
                  const matchedAccount = accountsheadardata.find(
                    (acc) =>
                      acc.MainAc_id === item.MainAc_id &&
                      acc.SubAc_id === item.SubAc_id &&
                      acc.SubsubAc_id === item.SubsubAc_id
                  );

                  return (
                    <tr key={index}>
                      <td className="tdcss">
                        {editRowId === item.Tr_Id ? (
                          <select
                            className="form-select"
                            value={editFormData.SubsubAc_id}
                            onChange={(e) => {
                              const selectedId = parseInt(e.target.value);
                              const selectedItem = accountsheadardata.find(
                                (acc) => acc.SubsubAc_id === selectedId
                              );
                              if (selectedItem) {
                                setEditFormData((prev) => ({
                                  ...prev,
                                  SubsubAc_id: selectedItem.SubsubAc_id,
                                  SubAc_id: selectedItem.SubAc_id,
                                  MainAc_id: selectedItem.MainAc_id,
                                  AccountName: selectedItem.AccountName,
                                  // Narration: selectedItem.AccountName
                                }));
                              }
                            }}
                          >
                            <option value="">Select Account</option>
                            {accountsheadardata.map((acc) => (
                              <option key={acc._id} value={acc.SubsubAc_id}>
                                {acc.AccountName}
                              </option>
                            ))}
                          </select>
                        ) : (
                          matchedAccount?.AccountName || "-"
                        )}
                      </td>

                      <td className="tdcss">
                        {editRowId === item.Tr_Id ? (
                          <input
                            type="text"
                            name="Narration"
                            value={editFormData.Narration}
                            onChange={handleEditChange}
                            className="form-control p-1"
                          />
                        ) : (
                          item.Narration
                        )}
                      </td>
                      <td className="text-end tdcss">
                        {editRowId === item.Tr_Id ? (
                          <input
                            type="number"
                            name="AmtCash"
                            value={editFormData.AmtCash}
                            onChange={handleEditChange}
                            readOnly
                            className="form-control text-end p-1"
                          />
                        ) : (
                          item.AmtCash
                        )}
                      </td>
                      <td className="text-end tdcss">
                        {editRowId === item.Tr_Id ? (
                          <input
                            type="number"
                            name="AmtBank"
                            readOnly
                            value={editFormData.AmtBank}
                            onChange={handleEditChange}
                            className="form-control text-end p-1"
                          />
                        ) : (
                          item.AmtBank
                        )}
                      </td>
                      <td className="tdcss">
                        {editRowId === item.Tr_Id ? (
                          <button
                            className="btn btn-primary btn-sm w-100"
                            onClick={() => handleEditSave(item.Tr_Id)}
                          >
                            Save
                          </button>
                        ) : (
                          <button
                            className="btn btn-warning btn-sm w-100"
                            onClick={() => handleEditClick(item)}
                          >
                            Edit
                          </button>
                        )}
                      </td>
                    </tr>
                  );
                })}
                <tr className="fw-bold text-end">
                                    <td colspan="2" className="text-start">Total</td>
                                    
                                    <td className="tdcss start-end">{totalAmtCash.toFixed(2)}</td>
                                    <td className="tdcss start-end">{totalAmtBank.toFixed(2)}</td>
                                    {/* <td>{totalCombined.toFixed(2)}</td> */}
                                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HoAccounts;
